<template>

  <el-dialog title="添加" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" :label-width="formLabelWidth">
      <el-form-item label="选择商品" prop="product_id">
         <template>
           <div>
             <el-button icon="el-icon-plus" @click.stop="$parent.openProduct(form.product,false)">选择产品</el-button>
           </div>

           <table v-if="form.product_id" border cellspacing="0" class="mt10" >
             <tr>
               <th class="w150">产品名称</th>
               <th class="w150">产品图片</th>
               <th class="w150">产品价格</th>
             </tr>
             <tr>
               <td class="tc">{{form.product.product_name}}</td>
               <td class="tc">{{form.product.product_name}}</td>
               <td class="tc">{{form.product.product_price}}</td>
             </tr>
           </table>
        </template>
      <!--组件样式-->
      </el-form-item>
      <el-form-item label="状态：">
        <el-radio-group v-model="form.status">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>
      <div v-if="form.status == 1">
        <el-form-item label="奖励类型：">
        <el-radio-group v-model="form.award_type">
          <el-radio :label="0">百分比</el-radio>
          <el-radio :label="1">固定金额</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="设置类型：">
        <el-radio-group v-model="form.type">
          <el-radio :label="0">统一设置</el-radio>
          <el-radio :label="1">独立设置</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="平级直推奖励：" prop="award" v-if="form.type==0">
        <el-input v-model="form.award" type="number" :min="0" :max="100" :step="1" placeholder="请输入比例" class="max-w460" 
        @input="changeMoney">
          <template slot="append" v-if="form.award_type==0">%</template>
          <template slot="append" v-if="form.award_type==1">元</template>
        </el-input>
        <div v-if="form.award_type==0 && form.award && form.product.product_price">
          ≈≈ {{(form.award * form.product.product_price*0.01 ).toFixed(2)}} 元
        </div>
      </el-form-item>
      <el-form-item label="平级间推奖励：" prop="jaward" v-if="form.type==0">
        <el-input v-model="form.jaward" type="number" :min="0" :max="100" :step="1" 
        placeholder="请输入比例" class="max-w460" @input="jchangeMoney">
          <template slot="append" v-if="form.award_type==0">%</template>
          <template slot="append" v-if="form.award_type==1">元</template>
        </el-input>
        <div v-if="form.award_type==0 && form.jaward && form.product.product_price && form.award != 0">
          ≈≈ {{(form.jaward * (form.award * form.product.product_price*0.01) * 0.01).toFixed(2)}} 元
        </div>
        <div>如商品为100元，直推奖励10%为10元，则间推奖励是直推奖励的10%为1元</div>
      </el-form-item>
      <el-form-item label="平级直推奖励：" v-if="form.type==1">
        <div  class="max-w460">
          <el-table
            :data="gradeList"
            border
            size="mini"
            style="width: 100%">
            <el-table-column
              prop="name"
              label="会员等级">
            </el-table-column>
            <el-table-column
              prop="name"
              label="奖励">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input v-model="scope.row.award" type="number" :min="0" :max="100" :step="1" placeholder="请输入奖励"></el-input>
                  <span class="ml10" v-if="form.award_type==0">%</span>
                  <span class="ml10" v-if="form.award_type==1">元</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="约等于">
              <template v-slot="scope">
                <div v-if="form.award_type == 0">
                  <div class="d-s-c" v-if=" form.product.product_price && scope.row.award">
                  {{ scope.row.award * form.product.product_price * 0.01 }}
                </div>
                <div v-else>0</div>
                </div>
                
                <div class="d-s-c" v-if="form.award_type == 1">
                  {{ scope.row.award  }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>
      <el-form-item label="平级间推奖励：" v-if="form.type==1">
        <div  class="max-w460">
          <el-table
            :data="jgradeList"
            border
            size="mini"
            style="width: 100%">
            <el-table-column
              prop="name"
              label="会员等级">
            </el-table-column>
      
            <el-table-column
              prop="name"
              label="奖励">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input v-model="scope.row.jaward" type="number" :min="0" :max="100" :step="1" placeholder="请输入奖励"></el-input>
                  <span class="ml10" v-if="form.award_type==0">%</span>
                  <span class="ml10" v-if="form.award_type==1">元</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              prop="name"
              label="约等于">
              <template v-slot="scope">
                <div v-if="form.award_type == 0 ">
                    <div class="d-s-c" v-if="form.product.product_price  && scope.row.jaward">
                    {{ (scope.row.jaward * 
                    (gradeList[scope.$index].award * form.product.product_price * 0.01 ) * 0.01 ).toFixed(2)}}
        
                    </div>
                  <div v-else>0</div>
                </div>
              
                <div class="d-s-c" v-if="form.award_type == 1">
                  {{ scope.row.jaward  }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div>如商品为100元，直推奖励10%为10元，则间推奖励是直推奖励的10%为1元</div>
      </el-form-item>

      <el-form-item label="是否开启级差：">
        <el-radio-group v-model="form.is_open_grade">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="差级复购奖励：" v-if="form.type==1">
        <div >
          <el-table
            :data="gradeList"
            border
            size="mini"
            style="width: 100%">
            <el-table-column prop="name" label="会员等级" width="200"></el-table-column>
            <el-table-column prop="name" label="奖励">
              <template v-slot="scope">
                <div class="d-s-c mt10" v-for="(item,index) in scope.row.gradeList" :key="index">
                  <div style="min-width: 100px;">{{item.name}}</div>
                  <el-input v-model="item.award" type="number" :min="0" :max="100" :step="1" placeholder="请输入奖励"></el-input>
                  <span class="ml10" v-if="form.award_type==0">%</span>
                  <span class="ml10" v-if="form.award_type==1">元</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>
      </div>
      



    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import LateralApi from '@/api/lateral.js';
export default {
  data() {
    return {
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      loading: false,
      /*是否显示*/
      dialogVisible: false,
      award: 0,//直推
      jaward:0,//间推
    };
  },
  props: ['open','form','gradeList','jgradeList'],
  watch: {
    open: function(n, o) {
      if (n != o) {
        this.dialogVisible = this.open;
      }
    },
  },
  created() {},
  methods: {
    /*转JSON字符串*/
    convertJson(list) {
      let obj = {};

      list.forEach(item => {
        if(item.award){
          obj[item.grade_id] = item.award;
        } else {
          obj[item.grade_id] = 0;
        }
      });

      return JSON.stringify(obj);
    },
    convertJsons(list) {
      let obj = [];
      let award = {};
      list.forEach((item, index) => {
        award = {};
        if(item.gradeList && item.gradeList.length>0){
          item.gradeList.forEach(res => {
            if(res.award){
              award[res.grade_id] = res.award;
            } else {
              award[res.grade_id] = 0;
            }
          });
        }
        obj[index] = {
          'grade_id': item.grade_id,
          'award': award,
        };
      });
      return JSON.stringify(obj);
    },
     /*转JSON字符串*/
     convertJson_j(list) {
      let obj = {};

      list.forEach(item => {
        if(item.jaward){
          obj[item.grade_id] = item.jaward;
        } else {
          obj[item.grade_id] = 0;
        }
      });

      return JSON.stringify(obj);
    },
    /*添加*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = self.form;
      params.award_detail = self.convertJson(self.gradeList);
      params.jaward_detail = self.convertJson_j(self.jgradeList)
      params.lateral_award = self.convertJsons(self.gradeList);
      console.log("self.form",self.form)
      LateralApi.addProduct(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，添加成功',
            type: 'success'
          });
          self.dialogFormVisible(true);
        })
        .catch(error => {
          self.loading = false;
        });
    },

    changeMoney(e){
      console.log(e)
    	let self = this;
      if(self.form.award_type==0 && self.form.product_id>0){
        if(e && e>0){
          var value = parseFloat(e);
          var product_price = parseFloat(self.form.product.product_price);
          var award = value * product_price*0.01;
          self.award = award.toFixed(2);
        } else {
          self.award = 0;
        }
      }
    },
    jchangeMoney(e){
      console.log(e)
    	let self = this;
      if(self.form.award_type==0 && self.form.product_id>0){
        if(e && e>0){
          var value = parseFloat(e);
          var jaward = value * self.award*0.01;
          self.jaward = jaward.toFixed(2);
        } else {
          self.jaward = 0;
        }
      }
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('close', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('close', {
          type: 'error',
          openDialog: false
        });
      }
    },

  }
};
</script>

<style>
  .w150{
    width: 150px;
    border-collapse: collapse;
  }
  .tc{
    text-align: center;
    border-collapse: collapse;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/lateral/product/dialog/Add.vue